import {h, Fragment, ComponentChildren, FunctionalComponent} from 'preact';
import {useStore} from 'effector-react';

import {$route} from 'libs/router/navigation.store';

interface IRouteProps {
    path: string;
    component: ComponentChildren,
    exact?: boolean,
}

export const Route: FunctionalComponent<IRouteProps> = ({component, path, exact = false}) => {
    const route = useStore($route);
    const visible = exact ?
        route === path :
        route.includes(path);

    return visible ? <Fragment>{component}</Fragment> : <Fragment/>;
};
